const Image = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.68 16.9596L18.55 9.64964C17.49 7.16964 15.54 7.06964 14.23 9.42964L12.34 12.8396C11.38 14.5696 9.59005 14.7196 8.35005 13.1696L8.13005 12.8896C6.84005 11.2696 5.02005 11.4696 4.09005 13.3196L2.37005 16.7696C1.16005 19.1696 2.91005 21.9996 5.59005 21.9996H18.35C20.95 21.9996 22.7 19.3496 21.68 16.9596Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.96997 8C8.62682 8 9.96997 6.65685 9.96997 5C9.96997 3.34315 8.62682 2 6.96997 2C5.31312 2 3.96997 3.34315 3.96997 5C3.96997 6.65685 5.31312 8 6.96997 8Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Image;
